import React from "react";

export default function Marquee({ words, className = "", speed = 60 }) {
  const doubled = [...words, ...words];
  return (
    <div className={`overflow-hidden py-6 border-y border-line ${className}`} data-testid="marquee">
      <div
        className="flex whitespace-nowrap"
        style={{
          animation: `marquee-slide ${speed}s linear infinite`,
          width: "max-content",
        }}
      >
        {doubled.map((w, i) => (
          <span
            key={i}
            className="font-display text-4xl sm:text-6xl lg:text-7xl font-black tracking-[-0.03em] flex items-center gap-14 pr-14 select-none"
          >
            <span>{w}</span>
            <span className="w-2.5 h-2.5 rounded-full bg-clay" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
}
